import React from 'react';
import { MarkerLayerRaw } from './MarkerLayer';

class FavoriteMarkerLayer extends React.Component {

  constructor(props) {
    super(props);
    this.translateFavoritesToGeoJson = this.translateFavoritesToGeoJson.bind(this);
  }

  translateFavoritesToGeoJson() {
    const favoritesJson = this.props.favorites.filter((item) => {
      if (!item.hide) {
        return true;
      }
      return false;
    }).map(item => ({
      key: item.locationcode,
      type: 'Feature',
      properties: { content: item.name },
      geometry: {
        type: 'Point',
        coordinates: [item.lon, item.lat]
      }
    })
    );
    return {
      data: {
        type: 'FeatureCollection',
        features: favoritesJson
      }
    };
  }

  render() {
    return <MarkerLayerRaw config={this.translateFavoritesToGeoJson()} />;
  }

}

export default FavoriteMarkerLayer;



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/FavoriteMarkerLayer.js
 **/